import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Box, Typography } from '@mui/material';

export default function SimpleBackdrop({
  show=true,
  message="Just a moment, the application is loading..."
}
) {
  const [open, setOpen] = React.useState(show);
  
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div>
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={show}
      >
        <CircularProgress color="inherit" />
          <Typography>
            {message}
          </Typography>
      </Backdrop>
    </div>
  );
}